import Icon from '../../../../baseComponents/gui/icon/Icon';

export default function Price({ coins, price }) {
  return (
    (coins || price) && (
      <div className={'button__coins button_transparent custom-button__coins'}>
        <Icon name={'coins'} />
      </div>
    )
  );
}
